/** Service status — chosen first, before branch */
export const STATUSES = [
  { key: 'active',   label: 'Active Duty',   abbr: 'AD'  },
  { key: 'veteran',  label: 'Proud Veteran', abbr: 'VET' },
  { key: 'retired',  label: 'Retired',       abbr: 'RET' },
];

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.key, s]));

/** Branch of service — chosen after status */
export const BRANCHES = [
  { key: 'army',       label: 'U.S. Army',            abbr: 'USA',  color: '#4b5320', accent: '#ffd700', symbol: 'star'     },
  { key: 'navy',       label: 'U.S. Navy',            abbr: 'USN',  color: '#001f5b', accent: '#c8a84b', symbol: 'anchor'   },
  { key: 'marines',    label: 'U.S. Marine Corps',    abbr: 'USMC', color: '#8b0000', accent: '#ffd700', symbol: 'eagle'    },
  { key: 'airforce',   label: 'U.S. Air Force',       abbr: 'USAF', color: '#00308f', accent: '#c0c0c0', symbol: 'wings'    },
  { key: 'coastguard', label: 'U.S. Coast Guard',     abbr: 'USCG', color: '#003087', accent: '#cc2200', symbol: 'anchor'   },
  { key: 'spaceforce', label: 'U.S. Space Force',     abbr: 'USSF', color: '#0d1b2a', accent: '#7b9db4', symbol: 'delta'    },
  { key: 'arng',       label: 'Army National Guard',  abbr: 'ARNG', color: '#3d4a20', accent: '#e0c060', symbol: 'star'     },
  { key: 'ang',        label: 'Air National Guard',   abbr: 'ANG',  color: '#1a3366', accent: '#ffd700', symbol: 'wings'    },
  { key: 'dod',        label: 'DoD Civilian',         abbr: 'DOD',  color: '#1a2e4a', accent: '#a0b8d0', symbol: 'pentagon', emblem: '/brand/branches/dod.svg' },
];

export const BRANCH_MAP = Object.fromEntries(BRANCHES.map((b) => [b.key, b]));

/**
 * Returns a combined display string, e.g.:
 *   "Active Duty · U.S. Marine Corps"
 *   "Proud Veteran · U.S. Army"
 *   "Retired · U.S. Navy"
 */
export function combinedLabel(statusKey, branchKey) {
  const s = STATUS_MAP[statusKey];
  const b = BRANCH_MAP[branchKey];
  if (!s && !b) return '';
  if (!s) return b?.label || '';
  if (!b) return s.label;
  return `${s.label} · ${b.label}`;
}
